<article class="flex w-full min-w-0 items-start gap-3">
    <div
        class="mt-0.5 grid size-8 shrink-0 place-items-center rounded-full bg-slate-900 text-[10px] font-bold text-white dark:bg-sky-100 dark:text-slate-900">
        TAI</div>
    <div class="min-w-0 flex-1">
        <div
            class="border-l-2 border-slate-200 px-4 py-2 text-sm leading-6 text-slate-700 dark:border-slate-700 dark:text-slate-200">
            <app-markdown-content [content]="message.text" />@if (message.messageFiles.length > 0) {
            <app-message-references [files]="message.messageFiles" (open)="reference.emit($event)" /> }</div>
        <div class="mt-2 flex flex-wrap items-center gap-1 text-[11px] text-slate-400"><span class="mr-2">TAI · {{
                message.date | date: 'shortTime' }}</span><button type="button" class="message-action"
                (click)="copyRequested.emit(message.text)">{{ 'copy' | transloco }}</button><button type="button" class="message-action"
                [class.active]="message.userReaction === 1" (click)="reaction.emit({ message, reaction: 1 })"
                [attr.aria-pressed]="message.userReaction === 1"
                [attr.aria-label]="'like' | transloco">♡ {{ 'like' | transloco }}</button><button type="button" class="message-action"
                [class.active]="message.userReaction === 2" (click)="reaction.emit({ message, reaction: 2 })"
                [attr.aria-pressed]="message.userReaction === 2"
                [attr.aria-label]="'dislike' | transloco">↓ {{ 'dislike' | transloco }}</button>@if (message.streaming) { <span
                class="ml-2 text-sky-500">{{ 'responding' | transloco }}</span> }</div>
    </div>
</article>
